import React from "react";
import { Video, Film, Scissors } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const services = [{
  title: "Gravação de Podcast em Estúdio Profissional",
  description: "Captação de áudio e vídeo em estúdio de podcast em Pinheiros, com equipamentos de alta qualidade e ambiente preparado para gravações profissionais. Ideal para empresas, especialistas e criadores que buscam elevar o nível do seu conteúdo.",
  icon: Video
}, {
  title: "Edição Profissional de Vídeo e Podcast",
  description: "Edição completa com montagem, colorização e tratamento de áudio para transformar sua gravação em um material profissional, pronto para publicação e com alto padrão visual.",
  icon: Film
}, {
  title: "Cortes Estratégicos para Redes Sociais",
  description: "Criação de cortes e vídeos curtos otimizados para Instagram, YouTube Shorts e outras plataformas, focados em retenção, alcance e crescimento da sua audiência.",
  icon: Scissors
}];
export default function ServicesSection() {
  return <section id="serviços" className="bg-background section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">Nossos Serviços de Produção de Podcast e Vídeo</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Estrutura completa em um só lugar: gravação, edição e cortes estratégicos para transformar seu conteúdo em autoridade.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className="bg-white border border-border rounded-xl shadow-sm transition-transform duration-200 ease-out hover:-translate-y-2 flex flex-col h-full">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-lg bg-primary/5 text-primary">
                  <service.icon className="h-7 w-7" strokeWidth={2} />
                </div>
                <CardTitle className="text-2xl font-default text-foreground">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="text-base text-muted-foreground leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}